module.exports = __webpack_public_path__ + "static/media/retiro.74d6c727.svg";